import axiosInstance from 'api/axiosInstance';

export interface SemanticResult {
  id: string;
  type: 'case';
  score: number;
  metadata: {
    caseId: string;
    title: string;
    customerName: string;
    statusTitle: string;
  };
}

interface SemanticSearchResponse {
  success: boolean;
  data: {
    results: SemanticResult[];
    query: string;
    count: number;
  };
}

const semanticSearch = async (query: string, topK: number = 5): Promise<SemanticSearchResponse> => {
  try {
    const { data } = await axiosInstance.post('/api3.2/search/semantic', { query, topK });
    return data;
  } catch (error) {
    console.error('[semanticSearch] Failed:', error);
    throw error;
  }
};

export default semanticSearch;
